var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',[_c('h1',[_vm._v(_vm._s(_vm.$t("contact")))]),_c('el-col',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('contact1'))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }